/*
 * Copyright (c) 2024-2025. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import React from 'react'
import clsx from 'clsx'

interface TableHeadWrapperProps {
    children: React.ReactNode | React.ReactNode[]
}

const TableHeadWrapper = (props: TableHeadWrapperProps) => {
    return (
        <thead
            className={clsx(
                'TableHeadWrapper sticky top-0 z-20 select-none',
                'font-medium tracking-wide',
                'bg-gray-100 dark:bg-gray-900',
                'shadow-sm text-gray-800',
                'dark:border-gray-800 dark:text-gray-100'
            )}
        >
            {props.children}
        </thead>
    )
}

export default TableHeadWrapper
